import React, { FC } from 'react';
import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';

import { Image as SharedImage } from './shared';

const Wrapper = styled.div<{ featured: boolean }>`
  padding: 0 0 12px 0;
  ${({ featured }) => media.md`
    transition: width 0.3s ease-in;
    width: ${featured ? '148px' : '0'};
    padding: 0 0 0 0;
    padding-right: ${featured ? '16px' : '0'};
    height: ${featured ? '132px' : '0'};
    overflow: hidden;

    &.open {
      width: 148px;
      height: 132px;
      padding-right: 16px;
    }
  `}
`;

type ImageProps = {
  alt: string;
  className?: string;
  featured: boolean;
  imageUrl: string;
  isWiderViewport: boolean;
};

const Image: FC<ImageProps> = ({ alt, className, featured, imageUrl, isWiderViewport }) => (
  <Wrapper featured={featured} className={className}>
    <SharedImage alt={alt} imageUrl={imageUrl} isWiderViewport={isWiderViewport} />
  </Wrapper>
);

export default Image;
